// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AZxb","colBig":"styles_colBig__21EjE","colSmall":"styles_colSmall__33Srx"};